module.exports = __webpack_public_path__ + "static/media/app-condutor-icone.6e3439b6.jp2";